import {
  Grid,
  Typography,
  Radio,
  FormControlLabel,
  RadioGroup,
} from '@mui/material';
import { useEffect } from 'react';
import { IFormRegister } from 'routes/Main/type';

interface Props extends IFormRegister {
  disabled?: boolean;
  setValue?: any;
  agreementInfo?: any;
  watch: any;
}

const ConsentForm = (props: Props) => {
  const { disabled, register, agreementInfo, setValue, watch } = props;
  useEffect(() => {
    if (agreementInfo?.pa_agreement) {
      setValue('pa_agreement', agreementInfo.pa_agreement);
    }
  }, [agreementInfo, setValue]);
  return (
    <Grid container spacing={2} sx={{ mt: 2, px: 3, userSelect: 'none' }}>
      {/* 1. 개인정보 수집 이용 동의 섹션 */}
      <Grid item xs={12}>
        <Typography variant="subtitle1" fontWeight="bold">
          1. 개인정보(초상권) 수집 이용 동의
        </Typography>
        <Grid container spacing={1} sx={{ ml: 2, mt: 1 }}>
          <Grid item xs={12}>
            <Typography>
              • 수집 목적: 실습 수업 운영의 질 관리, 평가용 영상 촬영
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography>
              • 수집 항목: 실습 교과목 수업 진행 및 학생 실어 영상
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography>
              • 이용 및 보유기간: 촬영 후 건호대학 인증 평가 종료 시까지
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography>
              • 영상 촬영에 대한 동의를 거부할 수 있으며, 미동의 시 해당 학생의
              영상 공개를 차단합니다.
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      {/* 2. 개인정보 제3자 제공 동의 섹션 */}
      <Grid item xs={12} sx={{ mt: 2 }}>
        <Typography variant="subtitle1" fontWeight="bold">
          2. 개인정보(초상권) 제3자 제공 동의
        </Typography>
        <Grid container spacing={1} sx={{ ml: 2, mt: 1 }}>
          <Grid item xs={12}>
            <Typography>
              • 제공 범위: 실습수업 참여 학생, 실습수업 진행 담당 교수, 간호대학
              교과목 인증 요원
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography>
              • 제공 목적: 실습 교과목 성찰 수업, 간호대학 인증
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography>
              • 제공 항목: 실습 교과목에 참여한 학생 및 교원의 영상
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography>
              • 촬영된 영상 공개에 대한 동의를 거부할 수 있으며, 미동의 시 해당
              학생의 영상 공개를 차단합니다.
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      {/* 동의 안내문 */}
      <Grid item xs={12} sx={{ mt: 2 }}>
        <Typography sx={{ mb: 2, fontWeight: 600 }}>
          위 내용에 근거하여, 실습 교과목 참여시 수업진행 중 영상 촬영과 영상의
          제3자 제공에 동의합니다.
        </Typography>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <RadioGroup
            value={watch('pa_agreement')}
            onChange={e => setValue('pa_agreement', String(e.target.value))}
          >
            <FormControlLabel
              {...register('pa_agreement')}
              value="1"
              control={<Radio color="primary" />}
              label="위 내용을 숙지하고 동의합니다."
            />
            <FormControlLabel
              {...register('pa_agreement')}
              value="2"
              control={<Radio color="primary" />}
              label="위 내용에 동의하지 않습니다."
            />
          </RadioGroup>
        </div>
      </Grid>
    </Grid>
  );
};

export default ConsentForm;
